import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'helpers/api';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import paths from 'routes/paths';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import moment from 'moment';
import AddNotesModal from 'components/hold/AddNotesModal';
import IconItem from 'components/common/icon/IconItem';
import { toast } from 'react-toastify';

const CycleOnHoldGrid = (props) => {

    const [showModal, setShowModal] = useState(false);
    const [holdCalledNote, setHoldCalledNote] = useState("");
    const [holdId, setHoldId] = useState("");
    const [refill, setRefill] = useState([]);
    let facilityData = localStorage.getItem("facilitiesData");
    useEffect(() => {

        fetchPatientData();

    }, [props.patientdetails_arr]);

    const columns = [
        {
            accessorKey: 'patient',
            header: 'Patient',
            meta: {
                headerProps: { className: 'text-900 text-start px-2 col-2' },
                cellProps: { className: 'text-start px-2 col-2' }
            }
        },
        {
            accessorKey: 'deliverydate',
            header: 'Delivery/Cycle Date',
            meta: {
                headerProps: { className: 'text-900 text-start px-2' },
                cellProps: { className: 'text-start px-2' }
            }
        },
        {
            accessorKey: 'rx',
            header: 'Rx',
            meta: {
                headerProps: { className: 'text-900 text-start w-10 px-2' },
                cellProps: { className: 'text-start px-2' }
            }
        },
        {
            accessorKey: 'drug',
            header: 'Drug',
            meta: {
                headerProps: { className: 'text-900 text-start w-10 px-2' },
                cellProps: { className: 'text-start px-2' }
            }
        },
        {
            accessorKey: 'status',
            header: 'Status',
            meta: {
                headerProps: { className: 'text-900 text-center' },
                cellProps: { className: 'text-center' }
            },
            cell: ({ row: { original } }) => (
                <div className="d-flex justify-content-center">
                    <Form.Select
                        size="sm"
                        value={original.get_hold_status}
                        onChange={(e) => handleHoldStatusChange(e, original.hold_id, original.rx)}
                    >
                        <option value="1">Hold</option>
                        <option value="0">Unhold</option>
                    </Form.Select>
                </div>
            )
        },
        {
            accessorKey: 'reasons',
            header: 'Reasons',
            meta: {
                headerProps: { className: 'text-900 text-start w-10 px-2' },
                cellProps: { className: 'text-start px-2' }
            }
        },
        {
            accessorKey: 'holdbydate',
            header: 'Hold By/Date',
            meta: {
                headerProps: { className: 'text-900 text-start w-10 px-2' },
                cellProps: { className: 'text-start px-2' }
            }
        },
        {
            accessorKey: 'called_date_reason',
            header: 'Called Date/Reason',
            meta: {
                headerProps: { className: 'text-900 text-start w-10' },
                cellProps: { className: 'text-start' }
            }
        },
        {
            accessorKey: 'action',
            header: 'Edit',
            cell: ({ row: { original } }) => (
                <IconItem
                    tag="button"
                    icon={['far', 'edit']}
                    size="sm"
                    onClick={() => openNotesModal(original.hold_id, original.get_called_reason)}
                />
            )
        }
        // {
        //     accessorKey: 'presstatus',
        //     header: 'Prescription Status',
        //     meta: {
        //         headerProps: { className: 'text-900 text-start w-10 px-2' },
        //         cellProps: { className: 'text-start px-2' }
        //     }
        // }

    ];

    const openNotesModal = (id, note) => {
        setHoldId(id);
        setHoldCalledNote(note);
        setShowModal(true);
    };

    const handleHoldStatusChange = async (e, holdId, rxId) => {
        const newStatus = e.target.value;
        const token = localStorage.getItem('accessToken');
        const payload = { hold_id: holdId, is_hold: newStatus };

        const { data: response } = await axios.post(`${process.env.REACT_APP_SERVER_URL}/drugs/update-hold-status/`, payload, {
            headers: { Authorization: `Bearer ${token}` }
        });

        if (response.status) {
            toast.success(`Rx ${rxId} updated successfully`);

            setRefill(prevFiltered =>
                prevFiltered.map(item =>
                    item.hold_id === holdId
                        ? { ...item, get_hold_status: newStatus }
                        : item
                )
            );
        }
    };


    async function fetchPatientData() {
        let reasonsResults = JSON.parse(localStorage.getItem("activeHoldReasonsData") || "[]");
        let results = [];
        // results.push({
        //     patient: 'DEMO 15, PATIENT',
        //     dob: '09/09/91',
        //     doctor: 'COMMUNITY, PELHAM',
        //     doctorphone: '7819662700',
        //     rx: '4367821',
        //     drug: 'METOPROLOL SUCCINATE',
        //     refill: '11',
        //     expiredate: '01/24/24',
        //     presstatus: 'Prescription has Expired'
        // });
        // setRefill(results);

        for (let patient in props.patientdetails_arr) {

            let patientlistObj = props.patientdetails_arr[patient];
            let refillObj = patientlistObj["prescriptions"].on_hold;

            refillObj.forEach((value) => {
                results.push({
                    patient: patientlistObj["patient_first"] + " " + patientlistObj["patient_last"],
                    dob: moment(patientlistObj["patient_dob"]).format('MM/DD/YY'),
                    deliverydate: moment(value.due_date).format('MM/DD/YY'),
                    hold_type: value.is_cycle === 1 ? 'Cycle' : 'Daily',
                    doctor: patientlistObj["doctor_first"] + " " + patientlistObj["doctor_last"],
                    doctorphone: patientlistObj["doctor_phone"],
                    rx: value.pharmacy_order_id,
                    drug: value.drug,
                    hold_id: value.id,
                    get_hold_status: value.is_hold,
                    reasons: reasonsResults.length > 0 ? reasonsResults.find((reason) => Number(reason.value) === Number(value.holdreason_id))?.key : null,
                    holdbydate: moment(value.hold_date).format('MM/DD/YY'),
                    presstatus: value.rx_status,
                    get_called_reason: value.called_note || '',
                    facility: facilityData ? JSON.parse(facilityData).find((facility) => Number(facility.value) === Number(value.facility_id))?.key : null,
                    called_date_reason: value.called_date ? moment(value.called_date).format('MM/DD/YY') + "/" + value.called_note : null
                })
            });
        }

        setRefill(results);
    }

    const table = useAdvanceTable({
        data: refill,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <AdvanceTableProvider {...table}>
            <AddNotesModal show={showModal} setShow={setShowModal} holdid={holdId} called_note={holdCalledNote} />
            <Row className='mt-3 justify-content-between'>
                <Col xs="4" className="mb-3">
                    <AdvanceTableSearchBox placeholder="Search..." />
                </Col>
            </Row>
            <Row>
                <Col xs="12" className="mb-1 mt-1">
                    <AdvanceTable
                        headerClassName="bg-200 text-nowrap align-middle text-center"
                        rowClassName="text-nowrap align-middle text-center"
                        tableProps={{
                            size: 'sm',
                            striped: true,
                            className: 'fs-10 mb-0 overflow-hidden'
                        }}
                    />
                </Col>
            </Row>
            <Card.Footer>
                <div className="mt-3">
                    <AdvanceTableFooter
                        rowInfo
                        navButtons
                        rowsPerPageSelection
                    />
                </div>
            </Card.Footer>
        </AdvanceTableProvider>
    );
};

export default CycleOnHoldGrid;
